import React, { useState, useEffect, useRef, useContext } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import NavBar from "../../Navigation/NavBar/NavBar";
import SideBar from "../../Navigation/SideBar/SideBar";
import Footer from "../../Footer/Footer";
import BtnScrollTop from "../../UI/Button/BtnScrollTop";
import Routing from "../../Route/Routing";
import { ThemeContext } from "../../Context/ThemeWrapper";
import * as CustomEvents from "../../Constants/CustomEvents"
import ComponentModal from "../../UI/Modal/ComponentModal";

import { faExclamation } from "@fortawesome/free-solid-svg-icons";

import styles from "./HomePage.module.scss";
import $ from "jquery";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "HOME_PAGE";

const HomePage = (props) => {
    const [toggled, setToggled] = useState(false);
    const homePageRef = useRef();
    const themeContext = useContext(ThemeContext);
    const [modal, setModal] = useState(null);
    const intl = useIntl();

    useEffect(() => {
        /* activate the tooltip features*/
        $(document).tooltip({//only enabled when document
            trigger: "hover", //only on focus (hide when click on button)
            selector: "[data-toggle=\"tooltip\"]", //to delegate (ie activate not only on first render)
            container: "body" //doesn't matter whether body or homePageRef.current
        });
        $(homePageRef.current).tooltip({
            trigger: "hover", //only on focus (hide when click on button)
            selector: "[data-tooltip]", //to delegate (ie activate not only on first render)
            container: homePageRef.current //doesn't matter whether body or homePageRef.current
        });
        // https://getbootstrap.com/docs/4.0/components/tooltips/
        // Tooltips are opt-in for performance reasons, so you must initialize them yourself.
        // Tooltips with zero-length titles are never displayed.
        // Specify container: 'body' to avoid rendering problems in more complex components (like our input groups, button groups, etc).
        // Tooltips must be hidden before their corresponding elements have been removed from the DOM.

        function loginActionsErrorHandler(event) {
            LogService.info(LOG_TAG, "useEffect didmount loginActionsErrorHandler");
            setModal(
                <ComponentModal
                    id="loginActionsErrorModal"
                    icon={faExclamation}
                    title={intl.messages.loginActionErrorModalTitle}
                    firstButtonLabel={intl.messages.close}
                    showModalOnInit={true}
                    onClick={() => setModal(null)}
                    onClose={() => setModal(null)}
                >
                    <div className="mb-2 text-center">
                        {intl.messages.loginActionErrorModalMessage}
                    </div>
                </ComponentModal>
            );
        };

        document.addEventListener(CustomEvents.CUSTOM_EVENT_LOGIN_ACTIONS_ERROR, loginActionsErrorHandler);

        return () => {
            //remove tooltip
            $("[data-toggle=\"tooltip\"]").tooltip("dispose");
            $("[data-tooltip]").tooltip("dispose");
            document.removeEventListener(CustomEvents.CUSTOM_EVENT_LOGIN_ACTIONS_ERROR, loginActionsErrorHandler);
        };
    }, [homePageRef.current]);

    function onSidebarToggleClicked() {
        LogService.info(LOG_TAG, "onSidebarToggleClicked");
        setToggled(!toggled);
    }

    LogService.trace(LOG_TAG, "render");

    return (
        <div ref={homePageRef}>
            <div className={themeContext.theme === "light" ? styles.banner : styles.darkbanner} />
            <NavBar
                isAuthenticated={props.user != null}
                status={toggled}
                onMenuToggleClick={() => onSidebarToggleClicked()}
            />

            <div className="wrapper d-flex">
                <SideBar
                    status={toggled}
                    user={props.user}
                />

                {/* <!-- Page Content --> */}
                <div id="content" className="w-100 py-0 px-3 mt-6">
                    <div className="container-fluid">
                        <Routing user={props.user} isInitialLoadFinished={props.isInitialLoadFinished} />
                        <BtnScrollTop />
                        <Footer />
                    </div>
                </div>
            </div>
            {modal}
        </div>
    );
}

HomePage.propTypes = {
    user: PropTypes.object,
    isInitialLoadFinished: PropTypes.bool
};

HomePage.defaultProps = {
    user: null,
    isInitialLoadFinished: false
}

export default HomePage;